import { Outlet, Route, Routes } from 'react-router-dom';

import { PageNotFound } from 'modules/common/components/PageNotFound';
import { dashboardRouteConfig } from 'modules/dashboard';
import { DefaultLayout } from 'modules/layout';
import { Dashboard } from 'modules/dashboard/screens/Dashboard';
import { GeoBlockingGuard } from 'modules/dashboard/screens/components/GeoBlockingGuard';
import { OCountryCode } from 'modules/common/const';
import { Withdrawal, withdrawalRouteConfig } from 'modules/withdrawal';

export function AppRoutes() {
  return (
    <Routes>
      <Route
        element={
          <GeoBlockingGuard asPage countryCodes={[OCountryCode.US]}>
            <DefaultLayout>
              <Outlet />
            </DefaultLayout>
          </GeoBlockingGuard>
        }
      >
        <Route element={<Dashboard />} path={dashboardRouteConfig.main.path} />

        <Route
          element={<Withdrawal />}
          path={withdrawalRouteConfig.main.path}
        />

        <Route element={<PageNotFound />} path="*" />
      </Route>
    </Routes>
  );
}
